
import PropTypes from 'prop-types'
import React from 'react'
import './Offscreen.css'

const Offscreen = ({ children }) => <div className='Offscreen'>{children}</div>

Offscreen.displayName = 'Offscreen'

Offscreen.propTypes = {
  children: PropTypes.node.isRequired
}

export default Offscreen



// WEBPACK FOOTER //
// ./ui/Offscreen.js